/* GESTOR DE HOTEL */

export default [
	{
		url: "/user/profile",
		name: "profile",
		slug: "profile",
		icon: "CreditCardIcon",
		i18n: "Clube",
		// i18n: "Checkin",
	},
	{
		url: "/geral/checkin",
		name: "Check-In Online",
		slug: "checkin",
		icon: "LogInIcon",
		// i18n: "Checkin",
	},
	{
		url: "/reservation/checkout",
		name: "Check-Out",
		slug: "check-out",
		icon: "LogOutIcon",
		needs_rsv: true,
		rsv_status: [5]
		// i18n: "Checkin",
	},
	{
		url: "/account",
		name: "Conta",
		slug: "account",
		icon: "CreditCardIcon",
		i18n: "client_account",
		needs_rsv: true,
		rsv_status: [4, 5]
	},
	{
		url: "/bookings",
		name: "Appointments",
		slug: "appointment",
		icon: "BookmarkIcon",
		i18n: "appointments",
		needs_rsv: false,
		rsv_status: [4, 5],
		hotel_ids: [1, 5, 6, 38, 10, 11, 7, 24, 3, 36, 35, 31, 29, 20, 32, 19, 21, 9, 24, 34, 23, 22, 14],
		submenu: [
			{
				url: '/booking/new',
				name: "Appointments",
				slug: "appointment",
				icon: "BookmarkIcon",
				i18n: "newa",
			},
			{
				url: '/my-bookings',
				name: "MyAppointments",
				slug: "my-appointment",
				icon: "BookmarkIcon",
				i18n: "consult",
			},
		]
	},
	{
		url: "/geral/menus",
		name: "Cartas",
		slug: "Menus",
		icon: "CoffeeIcon",
		i18n: "CartasSide",
	},
	{
		url: "/eCommerce",
		name: "Meus Pedidos",
		slug: "orders",
		icon: "ShoppingCartIcon",
		i18n: "Orders",
		submenu: [
			/*{
				url: '/eCommerce/orders',
				name: "Meus Pedidos",
				slug: "orders",
				icon: "ShoppingCartIcon",
				i18n: "Orders",
			},*/
			{
				url: '/geral/room-service',
				name: "Cartas",
				slug: "Menus",
				icon: "CoffeeIcon",
				i18n: "CartasSide",
			},
		]
	},
	{
		url: "/geral/spa",
		name: "Spa",
		slug: "spa",
		icon: "FeatherIcon",
		// i18n: "CartasSide",
	},
	{
		url: "/geral/entertainment",
		name: "Entretenimento",
		slug: "entertainment",
		icon: "Volume2Icon",
		i18n: "Entretenimento",
	},
	{
		url: "/geral/laundry",
		name: "Laundry",
		slug: "laundry",
		icon: "MapIcon",
		i18n: "laundry",
	},
	{
		url: "/geral/feedback",
		name: "Instant Feedback",
		slug: "instant-feedback",
		icon: "SmileIcon",
		i18n: "InstantFeedback",
	},
	{
		url: "/geral/questionario",
		name: "Questionário de Satifação",
		slug: "questionario",
		icon: "HelpCircleIcon",
		i18n: "QuestionarioSatisfacao",
	},
	{
        url: "/news/show",
        name: "Noticias",
        slug: "newsShow",
        icon: "BookOpenIcon",
        i18n: "Noticias",
    },
	{
		url: "/geral/directorio",
		name: "Directório A-Z",
		slug: "directorioaz",
		icon: "BookIcon",
		i18n: "DirectorioAZ",
	},
	{
		url: "/geral/informations",
		name: "Informations",
		slug: "informations",
		icon: "InfoIcon",
		i18n: "Informations",
	},
	{
	    url: "/geral/vgstar",
        name: "Vila Galé STAR",
        slug: "vgstar",
        icon: "StarIcon",
        i18n: "VilaGaleSTAR",
    },
	{
		url: "/geral/inovar-motivar",
		name: "Inovar Motivar",
		slug: "inovar-motivar",
		icon: "LoaderIcon",
		i18n: "Inovar_Motivar",
	},
	{
		url: "/geral/parcerias",
		name: "Parcerias",
		slug: "parcerias",
		icon: "CpuIcon",
		i18n: "Parcerias",
		user_type: "staff",
	},
	{
		url: "/geral/schedule",
		name: "schedule",
		slug: "schedule",
		icon: "CalendarIcon",
		i18n: "horarios",
		user_type: "staff",
	},
  	{
		url: '/admin/content',
		name: "Configuration",
		slug: "Configuration",
		icon: "GridIcon",  
		i18n: "Configuration",
		submenu: [
			{
				url: '/admin/content/main',
				name: "Homapage",
				slug: "main_page",
				i18n: "main_page",
			},
		    {
				url: '/admin/content/gerirConteudos/list',
				name: "gerirConteudos",
				slug: "gerirConteudos",
				i18n: "gerirConteudos",
			},
			{
				name: "Cartas",
				slug: "cartas",
				i18n: "Cartas",
				submenu: [
					{
						url: '/admin/content/cartas',
						name: "Carta",
						slug: "cartas",
						i18n: "Carta",
					},
					{
						url: '/admin/content/capitulos',
						name: "Capitulos",
						slug: "capitulos",
						i18n: "Chapters",
					},
					{
						url: '/admin/content/sub-capitulos',
						name: "Subcapitulos",
						slug: "subcapitulos",
						i18n: "Subcapitulos",
					},
					{
						url: '/admin/content/menu-setup',
						name: "Setup",
						slug: "menusetup",
						i18n: "MenuSetup",
					}
				]
			},
      	]
 	},
]
